import { getI18n } from 'react-i18next'
import { toast } from 'react-toastify'

export default function notifyServerError(traceId: string | null) {
  if (traceId !== null) {
    const content = getI18n().t('errors.serverError', { traceId })
    toast.error(content, {
      autoClose: false,
      closeOnClick: false,
      draggable: false,
    })
  }
}
